<template>
  <div class="tabla-riesgos">
    <el-table
      :data="risks"
      :default-sort = "{prop: 'mfl', order: 'descending'}"
      :row-class-name="tablaStatusClass"
      border
      style="width: 100%">
      <el-table-column
        :label="$t('Riesgo')"
        align="center"
        width="170">
        <template slot-scope="scope">
          <div class="nombre-riesgo">
            {{scope.row.nombre}}
          </div>
          <el-tag
            v-if="!scope.row.custom"
            class="tag-material">
            {{$t('Riesgo Estandarizado')}}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('Tipo Impacto')"
        min-width="160">
        <template slot-scope="scope">
          {{getMayorImpacto(scope.row).impacto.categoria}}
        </template>
      </el-table-column>
      <!-- <el-table-column
        :label="$t('Descripción Tipo Impacto')"
        min-width="160">
        <template slot-scope="scope">
          {{getMayorImpacto(scope.row).impacto.descripcion}}
        </template>
      </el-table-column> -->
      <el-table-column
        :label="$t('Escenarios')"
        min-width="160">
        <template slot-scope="scope">
          <el-col :md="24" v-if="scope.row.escenario">
            <b>Escenario</b>
            <br>
            {{scope.row.escenario}}
            <br>
          </el-col>
          <el-col :md="24" v-if="scope.row.escenario_residual">
            <b>Escenario Residual</b>
            <br>
            {{scope.row.escenario_residual}}
            <br>
          </el-col>
          <el-col :md="24" v-if="scope.row.escenario_mfl">
            <b>Escenario MFL</b>
            <br>
            {{scope.row.escenario_mfl}}
            <br>
          </el-col>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('Causas')"
        min-width="160">
        <template slot-scope="scope">
          <ol>
            <li
              v-for="(causa, i) in scope.row.causas"
              v-bind:key="i">
                {{causa.nombre}}
            </li>
          </ol>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('Controles Preventivos')"
        min-width="160">
        <template slot-scope="scope">
          <ol>
            <li
              v-for="(control, i) in getControlesPreventivos(scope.row)"
              v-bind:key="i"
              :class="tablaControlCritico(control)">
                {{control.nombre}}
            </li>
          </ol>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('Controles Mitigadores')"
        min-width="160">
        <template slot-scope="scope">
          <ol>
            <li
              v-for="(control, i) in getControlesMitigadores(scope.row)"
              v-bind:key="i"
              :class="tablaControlCritico(control)">
                {{control.nombre}}
            </li>
          </ol>
        </template>
      </el-table-column>
      <el-table-column
        prop="mfl"
        :label="$t('MFL')"
        width="90"
        align="center"
        sortable
        :sort-method="sortMFL">
        <template slot-scope="scope">
          <el-tag
          class="big"
          v-bind:type="mflRange(getMayorImpacto(scope.row).mfl)">
            {{getMayorImpacto(scope.row).mfl}}
        </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('FS')"
        align="center"
        width="80">
        <template slot-scope="scope">
          {{getMayorImpacto(scope.row).impacto.factor_severidad}}
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('FP')"
        align="center"
        width="80">
        <template slot-scope="scope">
          {{getMayorImpacto(scope.row).impacto.factor_probabilidad}}
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('RRR')"
        align="center"
        width="100">
        <template slot-scope="scope">
          <el-tag class="big" type="gray">{{getMayorImpacto(scope.row).rrr}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('NSR')"
        align="center"
        width="80">
        <template slot-scope="scope">
          {{getMayorImpacto(scope.row).impacto.nivel_severidad}}
        </template>
      </el-table-column>
      <el-table-column
        v-if="withStatus"
        :label="$t('Último Estado')"
        align="center"
        width="150">
        <template slot-scope="scope">
          <div v-if="scope.row.custom">
            <el-tag
              v-if="scope.row.status == 0 && scope.row.status_step != -1">
                {{$t('En revisión')}}
            </el-tag>
            <el-tag
              v-if="scope.row.status == 0 && scope.row.status_step == -1"
              type="warning">
                {{$t('Necesita arreglo')}}
            </el-tag>
            <el-tag
              v-if="scope.row.status == 1"
              type="success">
                {{$t('Aprobado')}}
            </el-tag>
            <p v-if="scope.row.status_by" class="statusUpdatedAt">
              {{scope.row.status_by}}
              <br>
              {{scope.row.status_updated_at | moment("DD MMM YYYY HH:mm")}}
            </p>
          </div>
          <div v-else>{{$t('No aplica')}}</div>
        </template>
      </el-table-column>
      <el-table-column
        v-if="withStatus"
        :label="$t('Comentario Estado')"
        min-width="250">
        <template slot-scope="scope">
          <div v-if="scope.row.custom">
            {{scope.row.status_message || $t('Sin comentarios')}}
          </div>
          <div v-else>No aplica</div>
        </template>
      </el-table-column>
      <el-table-column
        v-if="this.$store.getters.inventario.status == 1"
        :label="$t('Acción')"
        align="center"
        width="170">
        <template slot-scope="scope">
          <el-button
            size="small"
            v-if="canChangeRisk(scope.row)"
            icon="el-icon-edit"
            type="primary"
            @click="changeRisk(scope.row)">
              {{$t('Modificar')}}
          </el-button>
          <el-button
            size="small"
            v-if="canChangeStatus(scope.row)"
            icon="el-icon-check"
            type="primary"
            @click="openDialogVerificarEstado(scope.row)">
              {{$t('Revisar')}}
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      width="20%"
      :before-close="closeDialogVerificarEstado"
      :title="$t('REVISIÓN')"
      :visible="dialogVerificarEstado"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false">
      <el-form :model="status">
        <div v-if="actualRisk && getMayorImpacto(actualRisk).mfl == 3 && actualRisk.HSE_requested">
          <el-form-item :label="$t('Estado')">
            <el-select
              :class="{aprueba: status.status_step === 'true', rechaza: status.status_step === 'false'}"
              v-model="statusHSE.status"
              :placeholder="$t('Por favor seleccione un estado')"
              size="large"
              class="with-help-box fullWidth">
                <el-option style="background-color: green; color: white;" :label="$t('Revisado sin comentarios')" value="true"></el-option>
                <el-option style="background-color: red; color: white;" :label="$t('Revisado con comentarios')" value="false"></el-option>
            </el-select>
            <el-popover
              class="help-box"
              placement="top"
              :title="$t('Estado')"
              width="200"
              trigger="hover"
              :content="$t('Seleccione el estado de aprobación del riesgo. Si no aprueba la evaluación del riesgo, debe seleccionar \'Revisado con comentarios\'.')">
                <i slot="reference" class="el-icon-question"></i>
            </el-popover>
          </el-form-item>
          <el-form-item :label="$t('Comentario')">
            <el-input class="with-help-box" type="textarea" :rows="2" v-model="statusHSE.message"></el-input>
            <el-popover
              class="help-box"
              placement="top"
              :title="$t('Comentario')"
              width="200"
              trigger="hover"
              :content="$t('Especifique el motivo del rechazo del riesgo para que el  \'Coordinador \' corrija el riesgo.')">
                <i slot="reference" class="el-icon-question"></i>
            </el-popover>
          </el-form-item>
        </div>
        <div v-else>
          <el-form-item :label="$t('Estado')">
            <el-select
              v-model="status.status_step"
              :placeholder="$t('Por favor seleccione un estado')"
              size="large"
              class="with-help-box fullWidth">
                <el-option :label="$t('Revisado sin comentarios')" value="true"></el-option>
                <el-option
                  :label="$t('Consultar a HSE')" value="requestHSE"
                  v-if="actualRisk && getMayorImpacto(actualRisk).mfl == 3 && actualRisk.status_step == 2">
                </el-option>
                <el-option :label="$t('Revisado con comentarios')" value="false"></el-option>
            </el-select>
            <el-popover
              v-if="actualRisk && getMayorImpacto(actualRisk).mfl == 3 && actualRisk.status_step == 2"
              class="help-box"
              placement="top"
              :title="$t('Estado')"
              width="200"
              trigger="hover"
              :content="$t('Seleccione el estado de aprobación del riesgo. Si no aprueba la evaluación del riesgo, debe seleccionar \'Revisado con comentarios\'. En caso que necesite una opinión del HSE, debe seleccionar \'Consultar a HSE\'.')">
              <i slot="reference" class="el-icon-question"></i>
            </el-popover>
            <el-popover
              v-else
              class="help-box"
              placement="top"
              :title="$t('Estado')"
              width="200"
              trigger="hover"
              :content="$t('Seleccione el estado de aprobación del riesgo. Si no aprueba la evaluación del riesgo, debe seleccionar \'Revisado con comentarios\'.')">
                <i slot="reference" class="el-icon-question"></i>
            </el-popover>
          </el-form-item>
          <el-form-item
            label="Comentario"
            v-if="status.status_step === 'false' || status.status_step === 'requestHSE'">
              <el-input
                class="with-help-box"
                type="textarea"
                :rows="2"
                v-model="status.message">
              </el-input>
              <el-popover
                v-if="actualRisk && getMayorImpacto(actualRisk).mfl == 3 && actualRisk.status_step == 2"
                class="help-box"
                placement="top"
                title="Comentario"
                width="200"
                trigger="hover"
                :content="$t('Especifique el motivo del rechazo del riesgo para que el  \'Coordinador \' corrija el riesgo.')">
                  <i slot="reference" class="el-icon-question"></i>
              </el-popover>
              <el-popover
                v-else
                class="help-box"
                placement="top"
                title="Comentario"
                width="200"
                trigger="hover"
                :content="$t('Especifique el motivo del rechazo del riesgo para que el  \'Coordinador \' corrija el riesgo.')">
                  <i slot="reference" class="el-icon-question"></i>
              </el-popover>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialogVerificarEstado()">{{$t('Cancelar')}}</el-button>
        <el-button type="primary" @click="saveVerificarEstado()">{{$t('Guardar')}}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :before-close="closeChangeRisk"
      :title="$t('Modificando Riesgo')"
      width="60%"
      :visible="dialogChangeRiskVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false">
      <InventarioBowtie
        :editable="true"
        :risk="this.actualRisk"
        :addCause="addCause"
        :deleteCause="deleteCause"
        :addImpact="addImpact"
        :deleteImpact="deleteImpact"
        :addPreventiveControl="addPreventiveControl"
        :deletePreventiveControl="deletePreventiveControl"
        :addMitigationControl="addMitigationControl"
        :deleteMitigationControl="deleteMitigationControl" />

      <span slot="footer" class="dialog-footer">
        <el-button @click="closeChangeRisk()">{{$t('Cancelar')}}</el-button>
        <el-button type="primary" @click="saveRisk()">{{$t('Guardar')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue';
import uuid from 'uuid/v4';
import { Loading } from 'element-ui';
import InventarioBowtie from './InventarioBowtie.vue';

export default {
  data() {
    return {
      dialogChangeRiskVisible: false,
      dialogVerificarEstado: false,
      actualRisk: '',
      status: {
        status: '',
        status_step: '',
        message: '',
      },
    };
  },
  components: {
    InventarioBowtie,
  },
  props: [
    'risks',
    'withStatus',
    'task',
  ],
  methods: {
    canChangeRisk(risk) {
      if (
        risk.custom
        && parseInt(risk.status) === 0
        && parseInt(risk.status_step) === -1
        && (this.$store.getters.user.perfil === 'coordinator'
        || this.$store.getters.user.perfil === 'contractor_coordinator')
      ) {
        return true;
      }
      return false;
    },
    canChangeStatus(risk) {
      // Es predefinido
      if (!risk.custom) { return false; }
      // Ya no esta en revision
      if (parseInt(risk.status) !== 0) { return false; }
      // Esta siendo arreglado por Coordinador
      if (parseInt(risk.status_step) === -1) { return false; }

      // Casos segun MFL
      const { perfil } = this.$store.getters.user;
      const statusStep = parseInt(risk.status_step);
      const { mfl } = this.getMayorImpacto(risk);

      if (mfl < 3) {
        // Revision
        if (statusStep === 0 && perfil !== 'contractor_hse') {
          return false;
        }
        // Aprobacion
        if (statusStep === 1 && perfil !== 'administrator') {
          return false;
        }
      } else if (mfl === 3) {
        // Revision
        if (statusStep === 0 && perfil !== 'contractor_hse') {
          return false;
        }
        if (statusStep === 1 && perfil !== 'administrator') {
          return false;
        }
        // Aprobacion
        if (statusStep === 2 && perfil !== 'hse') {
          return false;
        }
        if (statusStep === 3 && perfil !== 'owner') {
          return false;
        }
      } else {
        // Para MFL > 3
        // Revision
        if (statusStep === 0 && perfil !== 'contractor_hse') {
          return false;
        }
        if (statusStep === 1 && perfil !== 'administrator') {
          return false;
        }
        // Aprobacion
        if (statusStep === 2 && perfil !== 'hse') {
          return false;
        }
        if (statusStep === 3 && perfil !== 'owner') {
          return false;
        }
        if (statusStep === 4 && perfil !== 'risk') {
          return false;
        }
        if (statusStep === 5 && perfil !== 'manager') {
          return false;
        }
      }
      return true;
    },
    changeRisk(riesgo) {
      // Copia objeto para poder modificarlo
      this.actualRisk = JSON.parse(JSON.stringify(riesgo));
      this.dialogChangeRiskVisible = true;
    },
    closeChangeRisk(riesgo) {
      this.$confirm(
        this.$t('Se perderán todos los cambios que haya realizado. ¿Está seguro de cancelar?'),
        this.$t('Atención'),
        { type: 'warning' },
      ).then(() => {
        this.dialogChangeRiskVisible = false;
      });
    },
    saveRisk() {
      this.$confirm(
        this.$t('Estos cambios serán sujetos a revisión. ¿Está seguro de continuar?'),
        this.$t('Atención'),
        { type: 'warning' },
      ).then(() => {
        this.actualRisk.status = 0;
        this.actualRisk.status_step = 0;
        const loadingInstance = Loading.service({ fullscreen: true });
        this.$store.dispatch('updateRiskReviewed', {
          inventory_id: this.$store.getters.inventario._id,
          task_id: this.task.id || this.task._id,
          risk: this.actualRisk,
        }).then((response) => {
          if (response.status) {
            this.$store.dispatch('getInventory', this.$store.getters.actualContract);
            this.$alert(
              this.$t('Riesgo actualizado y enviado a aprobación exitosamente.'),
              this.$t('Atención'), {
                type: 'success',
              },
            );
            this.dialogChangeRiskVisible = false;
          } else {
            this.$alert(
              this.$t('Lo sentimos, surgió un error al actualizar el riesgo. Intente nuevamente.'),
              this.$t('Atención'), {
                type: 'error',
              },
            );
          }
          loadingInstance.close();
        });
      });
    },
    saveVerificarEstado() {
      this.$confirm(
        this.$t('¿Está seguro de esta revisión? Un email de aviso será enviado'),
        this.$t('Atención'),
        { type: 'warning' },
      ).then(() => {
        const loadingInstance = Loading.service({ fullscreen: true });

        // Cambia status segun mfl y estado actual del paso
        let { status } = this.actualRisk;
        let statusStep = this.actualRisk.status_step;
        const { mfl } = this.getMayorImpacto(this.actualRisk);
        if (this.status.status_step === 'true') {
          statusStep += 1;
          if (mfl < 3) {
            if (statusStep === 2) {
              status = 1;
            }
          } else if (mfl === 3) {
            if (statusStep === 4) {
              status = 1;
            }
          } else if (statusStep === 6) {
            status = 1;
          }
        } else {
          statusStep = -1;
        }
        this.$store.dispatch('updateRiskStatus', {
          id: this.$store.getters.inventario._id,
          task_id: this.task.id || this.task._id,
          risk_id: this.actualRisk._id,
          status,
          status_step: statusStep,
          status_by: `${this.$store.getters.user.nombre} ${this.$store.getters.user.apellido}`,
          status_position: this.$store.getters.role.admin ? 'admin' : this.$store.getters.user.perfil,
          status_message: this.status.message,
        }).then((response) => {
          if (response.status) {
            this.$store.dispatch('getInventory', this.$store.getters.actualContract);
          } else {
            this.$alert(
              this.$t('Lo sentimos, surgió un error al actualizar estado. Intente nuevamente.'),
              this.$t('Atención'), {
                type: 'error',
              },
            );
          }
          loadingInstance.close();
        });
        this.closeDialogVerificarEstado();
      });
    },
    closeDialogVerificarEstado() {
      this.status.status_step = '';
      this.status.message = '';
      this.actualRisk = '';
      this.dialogVerificarEstado = false;
    },
    openDialogVerificarEstado(riesgo) {
      this.actualRisk = riesgo;
      this.dialogVerificarEstado = true;
    },
    getControlesPreventivos(risk) {
      const controles = [];
      const controlesId = {};

      risk.causas.forEach((causa, index) => {
        const id = `CA${index + 1}`;

        if (causa.controles_preventivos) {
          causa.controles_preventivos.forEach((control) => {
            if (!controlesId[control.nombre]) {
              controlesId[control.nombre] = true;
              control.id_causa = id;
              controles.push(control);
            }
          });
        }
      });

      return controles;
    },
    getControlesMitigadores(risk) {
      const controles = [];

      if (risk.impactos) {
        risk.impactos.forEach((impacto, index) => {
          const id = `IM${index + 1}`;

          if (impacto.controles_mitigadores) {
            impacto.controles_mitigadores.forEach((control) => {
              control.id_impacto = id;
              controles.push(control);
            });
          }
        });
      }

      return controles;
    },
    getMayorImpacto(risk) {
      let mfl = 0;
      let rrr;
      let mayorImpacto;

      if (risk.impactos) {
        risk.impactos.forEach((impacto) => {
          if (impacto.mfl > mfl) {
            mfl = impacto.mfl;
            rrr = (impacto.factor_severidad * 10) * (impacto.factor_probabilidad * 10) / (10 * 10);
            mayorImpacto = impacto;
          }
        });
      }

      return {
        impacto: mayorImpacto,
        mfl,
        rrr,
      };
    },
    mflRange(mfl) {
      if (mfl >= 4) {
        return 'danger';
      } if (mfl === 3) {
        return 'warning';
      }
      return 'gray';
    },
    sortMFL(a, b) {
      return this.getMayorImpacto(a).mfl >= this.getMayorImpacto(b).mfl;
    },
    tablaStatusClass(row, index) {
      if (this.withStatus) {
        return '';
      }
      const { mfl } = this.getMayorImpacto(row);
      if (mfl >= 4) {
        return 'row-danger';
      } if (mfl === 3) {
        return 'row-warning';
      }
      return '';
    },
    addCause(causa) {
      const cause = {
        id: uuid(),
        nombre: causa,
      };
      this.actualRisk.causas.push(cause);
    },
    deleteCause(causaId) {
      const causeIndex = this.actualRisk.causas.findIndex(cause => cause.id === causaId);
      Vue.delete(
        this.actualRisk.causas,
        causeIndex,
      );
    },
    addImpact(impacto) {
      const impact = {
        id: uuid(),
        ...impacto,
      };
      this.actualRisk.impactos.push(impact);
    },
    deleteImpact(impactoId) {
      const impactIndex = this.actualRisk.impactos.findIndex(impact => impact.id === impactoId);
      Vue.delete(
        this.actualRisk.impactos,
        impactIndex,
      );
    },
    addPreventiveControl(causasId, control) {
      causasId.forEach((causaId) => {
        const causeIndex = this.actualRisk.causas.findIndex(cause => cause.id === causaId);
        if (!this.actualRisk.causas[causeIndex].controles_preventivos) {
          Vue.set(
            this.actualRisk.causas,
            causeIndex,
            {
              ...this.actualRisk.causas[causeIndex],
              controles_preventivos: [],
            },
          );
        }
        const controlPreventivo = {
          id: uuid(),
          nombre: control,
        };
        this.actualRisk.causas[causeIndex].controles_preventivos.push(
          controlPreventivo,
        );
      });
    },
    deletePreventiveControl(causaId, controlId) {
      const causeIndex = this.actualRisk.causas.findIndex(cause => cause.id === causaId);
      const controlIndex = this.actualRisk.causas[causeIndex].controles_preventivos.findIndex(control => control.id === controlId);
      Vue.delete(
        this.actualRisk.causas[causeIndex].controles_preventivos,
        controlIndex,
      );
    },
    addMitigationControl(impactoId, control) {
      const impactIndex = this.actualRisk.impactos.findIndex(impact => impact.id === impactoId);
      if (!this.actualRisk.impactos[impactIndex].controles_mitigadores) {
        Vue.set(
          this.actualRisk.impactos,
          impactIndex,
          {
            ...this.actualRisk.impactos[impactIndex],
            controles_mitigadores: [],
          },
        );
      }
      const controlMitigador = {
        id: uuid(),
        nombre: control,
      };
      this.actualRisk.impactos[impactIndex].controles_mitigadores.push(
        controlMitigador,
      );
    },
    deleteMitigationControl(impactoId, controlId) {
      const impactIndex = this.actualRisk.impactos.findIndex(impact => impact.id === impactoId);
      const controlIndex = this.actualRisk.impactos[impactIndex].controles_mitigadores.findIndex(control => control.id === controlId);
      Vue.delete(
        this.actualRisk.impactos[impactIndex].controles_mitigadores,
        controlIndex,
      );
    },
    tablaControlCritico(risk) {
      if (risk.critico) {
        return 'control-critico';
      }
    },
  },
};
</script>

<style scoped>
.aprueba {
  border: 3px solid green; color: white;
}
.rechaza {
  border: 3px solid red; color: white;
}
.el-tag.big {
  font-size: 20px;
}
.el-tag--warning {
  color: rgb(61, 45, 31);
}
.statusUpdatedAt {
  font-size: 10px;
  color: gray;
}
.tag-material {
  margin-bottom: 7px;
}
.fullWidth {
  width: 100%;
}
.nombre-riesgo {
  word-break: break-word;
}
.tabla-riesgos {
  font-size: 12px;
}
</style>
